import { profileDescription } from './signal-lost-model.ts'

export const escapeHtml = (value: string): string => value.replace(/[&<>"']/g, c => ({
  '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
}[c]!))

/** Common axes for measured returns and references; never rescale to the local maximum. */
export function profileSvg(values: number[], label: string, reference?: number[]): string {
  const points = (data: number[]) => data.map((y, i) => `${(8 + i * 284 / (data.length - 1)).toFixed(1)},${(66 - y * 58).toFixed(1)}`).join(' ')
  return `<svg class="sl-profile" viewBox="0 0 300 74" role="img" aria-label="${escapeHtml(label + '. ' + profileDescription(values))}">
    <path class="sl-grid" d="M8 8V66H292 M8 37H292 M79 8V66 M150 8V66 M221 8V66"/>
    ${reference ? `<polyline class="sl-reference-trace" points="${points(reference)}"/>` : ''}
    <polyline class="sl-trace" points="${points(values)}"/>
  </svg>`
}
